import { useEffect, useRef, useState } from "react";
import { Check, Copy, FileCode } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import "./xboxScripts.css";

const SCRIPTS = [
  { filename: "xbox_xuid_collector.py", label: "xbox_xuid_collector.py", update: "TARGET_USERS = XXXXXXXX" },
  { filename: "xbox_collector.py", label: "Run Presence (Player count) data" },
  { filename: "xbox_metadata.py", label: "Run Metadata fetcher" },
].map((script) => ({
  ...script,
  command: `"C:\\Users\\broge\\AppData\\Local\\spyder-6\\envs\\spyder-runtime\\python.exe" "C:\\Users\\broge\\OneDrive\\Desktop\\Xbox\\${script.filename}"`,
}));

export default function XboxScripts() {
  const { currentUser } = useAuth();
  const [open, setOpen] = useState(false);
  const [copyState, setCopyState] = useState({});
  const wrapperRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const closeOutside = (event) => {
      if (!wrapperRef.current?.contains(event.target)) setOpen(false);
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
        buttonRef.current?.focus();
      }
    };
    document.addEventListener("pointerdown", closeOutside);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("pointerdown", closeOutside);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [open]);

  if (!currentUser?.is_admin) return null;

  const copyCommand = async (script) => {
    try {
      await navigator.clipboard.writeText(script.command);
      setCopyState((states) => ({ ...states, [script.filename]: "copied" }));
    } catch {
      setCopyState((states) => ({ ...states, [script.filename]: "failed" }));
    }
  };

  return (
    <div className="xbox-scripts" ref={wrapperRef}>
      <button
        type="button"
        className="xbox-scripts-toggle"
        ref={buttonRef}
        aria-expanded={open}
        aria-controls="xbox-scripts-panel"
        onClick={() => {
          setOpen((value) => !value);
          setCopyState({});
        }}
      >
        <FileCode size={13} aria-hidden="true" />
        Scripts
      </button>
      {open && (
        <section id="xbox-scripts-panel" className="xbox-scripts-panel" aria-label="Admin scripts">
          {SCRIPTS.map((script) => (
            <div className="xbox-script-entry" key={script.filename}>
              <strong>{script.label}</strong>
              {script.update && <div className="xbox-scripts-update">UPDATE: <code>{script.update}</code></div>}
              <div className="xbox-scripts-command-head">
                <span>Run locally:</span>
                <button type="button" onClick={() => copyCommand(script)} aria-label={`Copy ${script.filename} command`} title="Copy command">
                  {copyState[script.filename] === "copied" ? <Check size={15} /> : <Copy size={15} />}
                </button>
              </div>
              <textarea aria-label={`${script.filename} command`} readOnly value={script.command} onFocus={(event) => event.target.select()} />
              <div className="xbox-scripts-status" role="status">
                {copyState[script.filename] === "copied" ? "Command copied" : copyState[script.filename] === "failed" ? "Copy failed. Select the command and copy it manually." : ""}
              </div>
            </div>
          ))}
        </section>
      )}
    </div>
  );
}